export function normalizeLocale(value) {
    if (typeof value === 'string') {
        const normalized = value.toLowerCase();
        return normalized.startsWith('pt') ? 'pt' : 'en';
    }

    if (value && typeof value === 'object') {
        if (typeof value.value === 'string') {
            return normalizeLocale(value.value);
        }

        if (typeof value.name === 'string') {
            return normalizeLocale(value.name);
        }
    }

    return 'en';
}
